import { WORKFORCE_PAYROLL_ALLOWED_ROLES } from '@/lib/capabilities';
import { normalizeRole } from '@/lib/rbac';

/** Agency AP invoices are one completion path of workforce payroll review. */
export const AGENCY_INVOICE_ALLOWED_ROLES = WORKFORCE_PAYROLL_ALLOWED_ROLES;
export type AgencyInvoiceAllowedRole = (typeof AGENCY_INVOICE_ALLOWED_ROLES)[number];

export function canAccessAgencyInvoices(role: string | null | undefined): boolean {
  const normalised = normalizeRole(role);
  return Boolean(
    normalised && AGENCY_INVOICE_ALLOWED_ROLES.includes(normalised as AgencyInvoiceAllowedRole),
  );
}
